import {AgentNs} from '@shared/types';

export const agentTestRoutes = [
  {
    path: '/agent-test',
    name: AgentNs.AgentRouteEnums.AGENT_TEST,
    component: () => import('@domains/agent-test/views/agent-test.view.vue')
  },
  {
    path: '/agent-test/harness',
    name: AgentNs.AgentRouteEnums.AGENT_TEST_HARNESS,
    component: () => import('@domains/agent-test/views/agent-test-harness.view.vue'),
    meta: { requiresAuth: true }
  }
];
